import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { ChronologyFact } from '@/types';

interface UseUpdateChronologyFact {
  field: keyof ChronologyFact;
  value: ChronologyFact[keyof ChronologyFact];
  factId: string;
  chronologyId: string;
}

const useUpdateChronologyFact = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ field, value, factId, chronologyId }: UseUpdateChronologyFact) => {
      const fetchConfigPatch = getFetchConfig({ method: FetchMethod.PATCH, data: { [field]: value } });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/chronology/${chronologyId}/fact/${factId}`,
        fetchConfigPatch,
      );

      if (!response.ok) {
        toast.error('Failed to update field');
        throw new Error('Failed to update field');
      }

      return { chronologyId };
    },
    {
      onSuccess: ({ chronologyId }) => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.Chronology, { chronologyId }] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.ChronologyFacts, { chronologyId }] });
        toast.success('Chronology fact updated');
      },
      onError: (error) => {
        console.error('Update Error: ', error);
        toast.error('Failed to update field');
      },
    },
  );
};

export default useUpdateChronologyFact;
